import { ReportDateInterface } from '@/components/_common/ReportSelectMonthFields';
import { Moment } from 'moment';

export enum QuestReportType {
  totalPerWorkOrder,
  insurerPrivate,
  estimators,
  servicesAndPartsPerVehicle,
  workOrderCost,
  partStatus,
  workOrderPerArea,
}

export enum QuestReportOrderBy {
  situation,
  entryDate,
}

export enum QuestFilterDateBy {
  entry,
  authorization,
  closing,
  foreseenDelivery,
  delivery,
}

export enum QuestFilterByWorkOrderType {
  courtesy,
  warranty,
  workOrder,
  totalLoss,
  return,
  revision,
}

export enum QuestSituationOptions {
  open,
  authorized,
  closed,
  canceled,
}

export interface QuestWorkOrderReportFormValues extends ReportDateInterface {
  reportType: QuestReportType;
  filterDateBy: QuestFilterDateBy;
  orderBy: QuestReportOrderBy;
  filterByWorkOrderType: number[];
  situation: number[];
  estimatorsIds?: number[];
  customersIds?: number[];
  insurersIds?: string;
  vehiclesIds?: number[];
  brandsIds?: number[];
  modelsIds?: number[];
  isSynthetic?: boolean;
  isSyntheticGrouped?: boolean;
  includeParticular?: boolean;
  includeInsurer?: boolean;
  includeParts?: boolean;
  includePartsProvided?: boolean;
  includeServices?: boolean;
  includeServicesProvided?: boolean;
  finalDate: Moment;
  initialDate: Moment;
  commissionByLiquidValue?: string;
  isDetailComplementsInReport?: boolean;
  onlyBattery?: boolean;
  onlyPartnerDiscount?: boolean;
  IncludeCpf?: boolean;
  IncludeCnpj?: boolean;
}

export interface QuestWorkOrderRequest {
  reportResponseType: number;
  reportType: QuestReportType;
  companiesIds?: string;
  filterDateBy: QuestFilterDateBy;
  filterByWorkOrderType: string;
  filterBySituation?: string;
  estimatorsIds?: string;
  customersIds?: string;
  insurersIds?: string;
  vehiclesIds?: string;
  brandsIds?: string;
  modelsIds?: string;
  isSynthetic?: boolean;
  includeParticular?: boolean;
  includeParts?: boolean;
  includePartsProvided?: boolean;
  includeServices?: boolean;
  includeServicesProvided?: boolean;
  startDate: string;
  endDate: string;
  commissionByLiquidValue?: boolean;
  onlyBattery?: boolean;
  onlyPartnerDiscount?: boolean;
}
